/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_Token_Warning_Backend_Metadata_DescriptionInputs */

const en_shared_token_warning_backend_metadata_description = /** @type {(inputs: Shared_Token_Warning_Backend_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This asset is ready to surface warning-state treatments once backend metadata is available.`)
};

const de_shared_token_warning_backend_metadata_description = /** @type {(inputs: Shared_Token_Warning_Backend_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Vermögenswert kann Warnstatus-Darstellungen anzeigen, sobald Backend-Metadaten verfügbar sind.`)
};

const pt_br2_shared_token_warning_backend_metadata_description = /** @type {(inputs: Shared_Token_Warning_Backend_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este ativo está pronto para exibir tratamentos de alerta quando os metadados do backend estiverem disponíveis.`)
};

const tr_shared_token_warning_backend_metadata_description = /** @type {(inputs: Shared_Token_Warning_Backend_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu varlık, arka uç meta verileri kullanılabilir olduğunda uyarı durumu görünümlerini sunmaya hazırdır.`)
};

const zh_cn2_shared_token_warning_backend_metadata_description = /** @type {(inputs: Shared_Token_Warning_Backend_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该资产已准备就绪，待后端元数据可用后即可显示警示状态提示。`)
};

const zh_hk2_shared_token_warning_backend_metadata_description = /** @type {(inputs: Shared_Token_Warning_Backend_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`當後端中繼資料就緒後，此資產即可顯示警示狀態的處理方式。`)
};

const ko_kr2_shared_token_warning_backend_metadata_description = /** @type {(inputs: Shared_Token_Warning_Backend_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 자산은 백엔드 메타데이터가 준비되면 경고 상태 표시를 노출할 수 있습니다.`)
};

const ru_ru2_shared_token_warning_backend_metadata_description = /** @type {(inputs: Shared_Token_Warning_Backend_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот актив готов показывать предупреждения, как только появятся метаданные с бэкенда.`)
};

const es_419_shared_token_warning_backend_metadata_description = /** @type {(inputs: Shared_Token_Warning_Backend_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este activo está listo para mostrar tratamientos de estado de advertencia cuando los metadatos del backend estén disponibles.`)
};

/**
* | output |
* | --- |
* | "This asset is ready to surface warning-state treatments once backend metadata is available." |
*
* @param {Shared_Token_Warning_Backend_Metadata_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const shared_token_warning_backend_metadata_description = /** @type {((inputs?: Shared_Token_Warning_Backend_Metadata_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_Token_Warning_Backend_Metadata_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_token_warning_backend_metadata_description(inputs)
	if (locale === "de") return de_shared_token_warning_backend_metadata_description(inputs)
	if (locale === "pt-BR") return pt_br2_shared_token_warning_backend_metadata_description(inputs)
	if (locale === "tr") return tr_shared_token_warning_backend_metadata_description(inputs)
	if (locale === "zh-CN") return zh_cn2_shared_token_warning_backend_metadata_description(inputs)
	if (locale === "zh-HK") return zh_hk2_shared_token_warning_backend_metadata_description(inputs)
	if (locale === "ko-KR") return ko_kr2_shared_token_warning_backend_metadata_description(inputs)
	if (locale === "ru-RU") return ru_ru2_shared_token_warning_backend_metadata_description(inputs)
	return es_419_shared_token_warning_backend_metadata_description(inputs)
});